// import React from "react";
import { Link } from "react-router-dom";

import "./EducationTwoJoinSession.scss";

const EducationTwoJoinSession = () => {
  return (
    <section
      className="et_joinsession education_two_sect_padding"
      style={{
        backgroundImage: "url('./assets/img/educationtwo/session_bg.jpg')",
      }}
    >
      <img
        src="./assets/img/educationtwo/join_shape_one.png"
        alt=""
        className="shape_one shape d-none d-lg-block"
      />
      <img
        src="./assets/img/educationtwo/join_shape_two.png"
        alt=""
        className="shape_two shape d-none d-lg-block"
      />
      <div className="container">
        <div className="etj_inner">
          <div className="row">
            <div className="col-lg-8">
              <div className="etj_left">
                <h6>Join Our platform</h6>
                <h4>Call us at below given number for more information.</h4>
                <a href="tel:+1234567890" className="call-btn">
                  <span className="material-symbols-outlined icon">call</span>
                  +1 (234) 567-890
                </a>
              </div>
            </div>
            <div className="col-lg-4 mt-4 mt-lg-0">
              <div className="etj_right">
                <div className="video_area text-lg-center text-start">
                  <div className="video_icon pulse-animation">
                    <span className="material-symbols-outlined">
                      play_arrow
                    </span>
                  </div>
                  <Link className="click_link">Watch Now</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EducationTwoJoinSession;
